import { createSelector } from 'reselect';
import { AppState } from '../reducers';
import { AccountingState } from '../reducers/accounting.reducer';

const accountingState = (state: AppState): AccountingState => state.accounting;

export namespace AccountingSelectors {
  export const getProjectType = createSelector(
    [accountingState],
    (state: AccountingState) => state.projectData.projectType?.value,
  );

  export const getSiteData = createSelector(
    [accountingState],
    (state: AccountingState) => state.accountingSite,
  );

  export const getProjectData = createSelector(
    [accountingState],
    (state: AccountingState) => {
      const {
        FALocationNumber,
        projectBundleId,
        projectType,
        projectWorkType,
        projectSubtype,
        projectStatus,
        progressStatus,
        ATnTPM,
        siteAcqVendor,
        providenceAgent,
        civilVendor,
        notes,
      } = state.projectData;

      return {
        FALocationNumber,
        projectBundleId,
        projectType: projectType?.value,
        projectWorkType: projectWorkType?.value,
        projectSubtype: projectSubtype?.value,
        projectStatus: projectStatus?.value,
        progressStatus: progressStatus?.value,
        ATnTPM: ATnTPM?.value,
        siteAcqVendor: siteAcqVendor?.value,
        providenceAgent:
          providenceAgent?.firstName && providenceAgent?.lastName
            ? `${providenceAgent.firstName} ${providenceAgent.lastName}`
            : undefined,
        civilVendor: civilVendor?.value,
        notes,
      };
    },
  );

  export const getNotesData = createSelector(
    [accountingState],
    (state: AccountingState) => state.notes,
  );

  export const getAccountingBrowseData = createSelector(
    [accountingState],
    (state: AccountingState) => state.accountingBrowseData,
  );
}
